import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapSettingsCards = {
  index: async(props) => {
    const { default: CardsSettings } = await import('@/vue_widgets/mlap/settings/cards/index.vue')
    createVueApp(CardsSettings, { props })
  }
}
